import conductorService from '@/api/conductorService'
import store from '@/store'
import { SessionResponse } from '@/types/conductor'

export function getSessionId() {
  const sessionId: string = store.getters['sessionModule/sessionId']
  if (sessionId === null || sessionId === undefined || sessionId.length <= 0) {
    return null
  }

  return sessionId
}

export async function initialiseSession() {
  const sessionId = getSessionId()
  if (sessionId === null) {
    console.log('No session - create new')
    const sessionResponsePromise = conductorService.getSession()

    const sessionResponse: SessionResponse = await sessionResponsePromise
    await store.dispatch(
      'sessionModule/setSessionId',
      sessionResponse.sessionId,
    )
  }
}
